/**
 * マーク・アイコンマスタ画面のアイコン情報一覧クラス
 *
 * @export CwsIconDataForView
 * @class CwsIconDataForView
 */
export class CwsIconDataForView {
    public check = false;
    constructor(
        public delivEndDate: string,
        public iconGroupCode: string,
        public iconGroupName: string,
        public iconCode: string,
        public iconCodeBranch: string,
        public iconName: string,
        public iconImageUrl: string,
        public iconAlternativeText: string,
        public delivCatalogIdStart: string,
        public delivCatalogIdEnd: string,
        public iconDiv: string,
        public arrangeDiv: string,
        public iconExplain: string,
        public outputDivStr: string,
        // 使用終了判定用フラグ
        public delivEndFlg: boolean,
        public updateDate: string
    ) { }
}
